// import { formatPriceWithoutSymbol } from '@/utils/price';
import JDICurrencySymbol from '../currencySymbol';
import { formatCurrency } from '@/utils/price';
interface props {
  price: string;
  symbolStyle?: React.CSSProperties;
  integerStyle?: React.CSSProperties;
  decimalPointStyle?: React.CSSProperties;
  decimalPlaceStyle?: React.CSSProperties;
  lineThrough?: boolean;
  containerStyle?: React.CSSProperties;
  inLineStyles?: React.CSSProperties;
  uiType?: number; // 内置ui类型
  locale?: string;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  errorIsShowAmount?: boolean; // 出现错误是否展示金额
}

const JDIPrice = (props: props) => {
  let {
    // symbol,
    containerStyle = {},
    symbolStyle = {},
    integerStyle = {},
    decimalPlaceStyle = {},
    decimalPointStyle = {},
  } = props;
  const {
    price,
    lineThrough = false,
    inLineStyles = {},
    uiType = 1,
    locale,
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
    errorIsShowAmount,
  } = props;

  if (price === undefined || price === null || price === '' || isNaN(parseFloat(price))) {
    return null;
  }

  containerStyle = Object.assign({ fontWeight: 700 }, containerStyle, inLineStyles);

  if (lineThrough) {
    Object.assign(symbolStyle, { textDecoration: 'line-through' });
    Object.assign(integerStyle, { textDecoration: 'line-through' });
    Object.assign(decimalPointStyle, { textDecoration: 'line-through' });
    Object.assign(decimalPlaceStyle, { textDecoration: 'line-through' });
  }
  if (uiType === 1) {
    containerStyle = Object.assign(
      {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '32px',
        color: '#1a1a1a',
      },
      containerStyle,
    );
    symbolStyle = Object.assign({}, symbolStyle);
    integerStyle = Object.assign({ fontSize: '28px' }, integerStyle);
    decimalPlaceStyle = Object.assign({}, decimalPlaceStyle);
    decimalPointStyle = Object.assign({}, decimalPointStyle);
  } else if (uiType === 2) {
    containerStyle = Object.assign(
      { height: '28px', lineHeight: '28px', color: '#888b94' },
      containerStyle,
    );
    symbolStyle = Object.assign({}, symbolStyle);
    integerStyle = Object.assign({}, integerStyle);
    decimalPlaceStyle = Object.assign({}, decimalPlaceStyle);
    decimalPointStyle = Object.assign({}, decimalPointStyle);
  }
  const formatResult = formatCurrency(parseFloat(price), {
    locale,
    currency,
    currencyDisplay: 'symbol', // 强制使用符号而不是代码
    minimumFractionDigits,
    maximumFractionDigits,
    errorIsShowAmount,
  });

  const {
    integerPart,
    decimalPlace,
    sign,
    symbolPosition,
    symbol,
    decimalSeparator,
    isError,
    full,
    spacingPosition,
  } = formatResult;

  // price = formatPriceWithoutSymbol(parseFloat(price));
  // let integerPart, decimalPlace;
  // if (price.includes('.')) {
  //   [integerPart, decimalPlace] = price.split('.');
  // } else {
  //   integerPart = price;
  //   decimalPlace = '00';
  // }
  return (
    price && (
      <span style={containerStyle}>
        {isError && full ? (
          <>
            <span style={integerStyle}>{full}</span>
          </>
        ) : (
          <>
            <span>{sign}</span>
            {symbolPosition === 'before' && (
              <JDICurrencySymbol symbol={symbol} style={symbolStyle} />
            )}
            {spacingPosition === 'after-symbol' && <span>&nbsp;</span>}
            <span style={integerStyle}>{integerPart}</span>
            {decimalPlace && <span style={decimalPointStyle}>{decimalSeparator}</span>}
            <span style={decimalPlaceStyle}>{decimalPlace}</span>
            {spacingPosition === 'before-symbol' && <span>&nbsp;</span>}
            {symbolPosition === 'after' && (
              <JDICurrencySymbol symbol={symbol} style={symbolStyle} />
            )}
          </>
        )}
      </span>
    )
  );
};

export default JDIPrice;
